export default (aa)=>{
    if(aa){
      let timestamp4 = new Date(aa);//直接用 new Date(时间戳) 格式转化获得当前时间
      let result=timestamp4.toLocaleDateString().replace(/\//g, "-") + " " + timestamp4.toTimeString().substr(0, 8)
      return result
    }else{
      return ''
    }
  }



// WEBPACK FOOTER //
// ./src/filter/timestamp.js